import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSortDescend = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "26px",
	height: "20px",
	viewBox: "0 0 26 20",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "icon-sort-descend" }), /* @__PURE__ */ _jsx("g", {
		id: "Page-1",
		stroke: "none",
		strokeWidth: 1,
		children: /* @__PURE__ */ _jsx("g", {
			id: "icon-sort-descend",
			children: /* @__PURE__ */ _jsxs("g", {
				id: "Sort-Button",
				transform: "translate(1.000000, 1.000000)",
				children: [
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle-path",
						transform: "translate(8.090909, 1.780488) rotate(90.000000) translate(-8.090909, -1.780488) ",
						x: 7.09090909,
						y: -6.02439024,
						width: 2,
						height: 15.6097561,
						rx: 1
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle-path",
						transform: "translate(7.303030, 7.463415) rotate(90.000000) translate(-7.303030, -7.463415) ",
						x: 6.3030303,
						y: .43902439,
						width: 2,
						height: 14.0487805,
						rx: 1
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle-path",
						transform: "translate(6.121212, 13.146341) rotate(90.000000) translate(-6.121212, -13.146341) ",
						x: 5.12121212,
						y: 7.29268293,
						width: 2,
						height: 11.7073171,
						rx: 1
					}),
					/* @__PURE__ */ _jsxs("g", {
						id: "arrow",
						transform: "translate(14.939394, 1.000000)",
						children: [
							/* @__PURE__ */ _jsx("rect", {
								id: "Rectangle-path",
								transform: "translate(3.121276, 13.173286) rotate(-45.000000) translate(-3.121276, -13.173286) ",
								x: 2.12127562,
								y: 10.0513343,
								width: 2,
								height: 6.24390244,
								rx: .780487805
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rectangle-path",
								transform: "translate(6.463962, 13.173286) rotate(45.000000) translate(-6.463962, -13.173286) ",
								x: 5.46396202,
								y: 10.0513343,
								width: 2,
								height: 6.24390244,
								rx: .780487805
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rectangle-path",
								transform: "translate(4.792619, 7.804878) rotate(0.000000) translate(-4.792619, -7.804878) ",
								x: 3.79261882,
								y: 197530881e-20,
								width: 2,
								height: 15.6097561,
								rx: .780487805
							})
						]
					})
				]
			})
		})
	})]
});
export default SvgSortDescend;
